import { useParams } from 'react-router-dom';

import AILeader from './AILeader';
import DigitalLeader from './DigitalLeader';

const GCPOverview = () => {
  const { subId } = useParams();

  return (
    <>
      {subId === 'GOOGLE_CLOUD_DIGITAL_LEADER' && <DigitalLeader />}
      {subId === 'GOOGLE_AI_LEADER' && <AILeader />}
    </>
  );
};

export default GCPOverview;
